/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

/* Import configuration */
import { CSV_SENSOR_MUENSTER, CSV_SENSOR_NEUTRAUBLING } from '@/config/csvSensors';

/* Import libraries */
import { getCsvSensorSystems } from '@/lib/sensors/csv/csvToSensorMetadata';

export interface SystemSectionConfig {
    name: string;
}

function createSystemSectionConfigs(): SystemSectionConfig[] {
    return Array.from(
        new Set([
            ...getCsvSensorSystems(CSV_SENSOR_MUENSTER),
            ...(CSV_SENSOR_NEUTRAUBLING === null ? [] : getCsvSensorSystems(CSV_SENSOR_NEUTRAUBLING)),
        ]),
    )
        .sort((leftSystem, rightSystem) => leftSystem.localeCompare(rightSystem))
        .map((name) => ({ name }));
}

export let SYSTEM_SECTION_CONFIGS = createSystemSectionConfigs();

export function refreshSystemSectionConfigs(): void {
    SYSTEM_SECTION_CONFIGS = createSystemSectionConfigs();
}
